import React from 'react'
import { findDOMNode } from 'react-dom'
import './Footnote.css'

class Footnote extends React.Component {
  constructor(props) {
    super(props)
    this.state = { open: false }
  }
  open() {
    const { size } = this.props
    const { top, left, right } = findDOMNode(this).getBoundingClientRect()
    const margin = 30
    const boxWidth = size[0] || (window.innerWidth / 2)
    const canAnchorLeft = left < window.innerWidth - boxWidth - margin
    const canAnchorRight = right - boxWidth > margin
    const anchorOffset = !canAnchorLeft && !canAnchorRight 
      ? -left + (window.innerWidth - margin - boxWidth) 
      : null
    this.setState({
      open: true,
      anchorLeft: canAnchorLeft || !(canAnchorLeft || canAnchorRight),
      anchorOffset: anchorOffset,
      anchorTop: top < window.innerHeight - (size[1] || window.innerHeight / 2) - margin,
    })
  }
  close() {
    this.setState({ open: false })
  }
  render() {
    const { size: [width, height], mark, children, anchorLeft, anchorTop } = this.props
    const shouldAnchorLeft = anchorLeft != null ? anchorLeft : this.state.anchorLeft
    const shouldAnchorTop  = anchorTop  != null ? anchorTop  : this.state.anchorTop
    const anchorOffset = this.state.anchorOffset
    return (
      <span
        className={`Footnote ${this.state.open ? 'open' : ''} ${shouldAnchorLeft ? 'anchorLeft' : ''} ${shouldAnchorTop ? 'anchorTop' : ''}`}
        onTouchEnd={() => { this.open() }}
        onMouseEnter={() => { this.open() }}
        onMouseLeave={() => { this.close() }}
      >
        <span className="Footnote-screen"
          onTouchEnd={event => { this.close(); event.stopPropagation() }}
          onMouseOver={event => { this.close(); event.stopPropagation() }}
        />

        <span className="Footnote-clipboard"> Note </span>
        <sup>
          {this.state.open ? <em>{mark}</em> : mark}
          <span className="Footnote-touchpoint" />
        </sup>
        <span className="Footnote-clipboard">: </span>

        <span
          className="Footnote-note"
          style={{ 
            width, 
            maxHeight: height || Math.floor(window.innerHeight / 2 / 17) * 17,
            left: anchorOffset 
          }}>{children}</span>
      </span>
    )
  }
}
Footnote.defaultProps = {
  mark: '*',
  size: [242, null],
}

export default Footnote



// WEBPACK FOOTER //
// ./src/Footnote.js